import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsDe from 'shared/texts/de.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      de: translationsDe
    },
    lng: 'de',
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    debug: true
  });

export default i18n;
